const UitkListOrientationMap = [
  ["inline", "orientation-inline"],
  ["stacked", "orientation-stacked"]
];
export const UitkListOrientations = new Map(UitkListOrientationMap);
const UitkListSizeMap = [
  [1, "size-1"],
  [2, "size-2"],
  [3, "size-3"]
];
export const UitkListSizes = new Map(UitkListSizeMap);
const UitkListTypeMap = [
  ["unordered", "ul"],
  ["ordered", "ol"]
];
export const UitkListTypes = new Map(UitkListTypeMap);
const UitkListBulletMap = [
  ["default", "bullet-default"],
  ["no-bullet", "bullet-none"],
  ["icon-alternate", "bullet-icon-alternate"],
  ["icon-standard", "bullet-icon-standard"]
];
export const UitkListBullets = new Map(UitkListBulletMap);
const UitkListItemThemeMap = [
  ["default", "default-theme"],
  ["emphasis", "emphasis-theme"],
  ["positive", "positive-theme"],
  ["negative", "negative-theme"]
];
export const UitkListItemThemes = new Map(UitkListItemThemeMap);
